<template>
  <v-card>
    <v-navigation-drawer bottom mobile-breakpoint="3600" v-model="drawer" app>
      <v-list v-if="isLogged" nav dense>
        <v-list-item v-for="item in linksForLoggedUserMobile" :key="item.text" :to="item.link">
          {{ item.text }}
        </v-list-item>
        <v-list-item @click="logout()">
          Odhlásiť
        </v-list-item>
      </v-list>
      <v-list v-else>
        <v-list-item v-for="item in links" :key="item.text" :to="item.link">
          {{ item.text }}
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="secondary">
      <router-link to="/">
        <v-img
          center
          max-height="60"
          max-width="170"
          src="../assets/logo_icl.png"
        />
      </router-link>
      <v-spacer />
      <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer" />
      <v-spacer v-if="$vuetify.breakpoint.mdAndUp" />
      <div v-if="isLogged">
        <v-btn
          v-for="item in linksForLoggedUser"
          :key="item.text"
          :to="item.link"
          color="black"
          text
          rounded
          class="hidden-sm-and-down"
        >
          {{ item.text }}
        </v-btn>
        <v-btn color="black" text rounded class="hidden-sm-and-down">
          <my-avatar></my-avatar>
        </v-btn>
      </div>
      <div v-else>
        <v-btn
          v-for="item in links"
          :key="item.text"
          :to="item.link"
          color="black"
          text
          rounded
          class="hidden-sm-and-down"
        >
          {{ item.text }}
        </v-btn>
      </div>
    </v-app-bar>
  </v-card>
</template>

<script>
  import axios from 'axios';
  import store from "../store/store";
  import MyAvatar from "./myAvatar";
  export default {
    name: "MyHeader",
    components: {MyAvatar},
    data: () => ({
      drawer: false,
      links: [
        {
          text: 'Objednanie upratovania',
          link: '/'
        },
        {
          text: 'Moje objednávky',
          link: 'userOrders'
        },
        {
          text: 'Prihlásenie upratovača',
          link: 'login'
        }
      ],
      linksForLoggedUser: [
        {
          text: 'Schvaľovanie objednávok',
          link: 'newOrders'
        },
        {
          text: 'Voľné termíny',
          link: 'termsAdministration'
        }
      ],
      linksForLoggedUserMobile: [
        {
          text: 'Schvaľovanie objednávok',
          link: 'newOrders'
        },
        {
          text: 'Voľné termíny',
          link: 'termsAdministration'
        },
        {
          text: 'Objednávky',
          link: 'userDashboard'
        },
        {
          text: 'Recenzie',
          link: 'reviews'
        },
        {
          text: 'Profil',
          link: 'profile'
        }
      ]
  }),
  methods: {
    checkIfIsLogged() {
      if(localStorage.getItem('isLogged') == 'logged'){
        this.$router.push({name: 'userDashboard'});
        store.commit("setLoggedUser", {
          name:localStorage.getItem('loggedUserName'),
          surname: localStorage.getItem('loggedUserSurname'),
          id:localStorage.getItem('loggedUserId')
        });
      }
    },
    logout() {
      axios.get( store.state.url.concat("logout.php")).then(response => {
        if (response.data.result == "ok") {
          localStorage.setItem('isLogged', 'notLogged');
          localStorage.setItem('loggedUserName', '');
          localStorage.setItem('loggedUserSurname', '');
          localStorage.setItem('loggedUserId', '');
          store.commit("logout");
          this.$router.push({ name: "home" });
        }
      });
    },
    created() {
      this.checkIfIsLogged();
    }
  },
  computed: {
    isLogged() {
      store.state.isLogged = (localStorage.getItem('isLogged') == 'logged');
      //return localStorage.getItem('isLogged') == 'logged';
      return store.state.isLogged;
    },
    getUserName() {
      store.state.name = localStorage.getItem('loggedUserName');
      //return localStorage.getItem('loggedUserName');
      return store.state.name;
    },
    getUserSurname() {
      store.state.name = localStorage.getItem('loggedUserSurname');
      //return localStorage.getItem('loggedUserSurname');
      return store.state.surname;
    }
  }
};
</script>
<style>
a {
  text-decoration: none;
}
</style>
